module.exports = __webpack_public_path__ + "static/media/air-canada.147f4192.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/air-canada.svg
// module id = 91
// module chunks = 3